import {
    GenericFormContainer,
    Grid,
    IAlertData,
    Leap4Breadcrumbs,
    setAlert,
    Mode,
    MuiIcons,
    Toc as TocIcon
} from "@leap4/frontend";
import {CreateGroupStore} from "./CreateGroupStore";
import {useHistory} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {IGroup} from "../../interfaces/IGroup";
import {initialGroupObj} from "../base/Group";
import {ApiClient} from "../../../../../utils/apiClient";
import {urlService} from "../../../../routing/urlsService";
import {DetailsForm} from "../base/DetailsForm"
import {GroupContext} from "../base/GroupContex"
import {RootState} from "../../../../../store/store";
import {connect} from "react-redux";
import {GroupsBaseUrl} from "../../../../../config/generals";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../../../shared/OneOrgOnly/OneOrgOnly";

const {Groups: GroupsIcon} = MuiIcons;

export interface IAddGroupProps {
    setGroup: (data: IAlertData) => void;
}

let store: CreateGroupStore

const _addGroup = (props: IAddGroupProps) => {
    const history = useHistory();
    const [group, setGroup] = useState<IGroup>(initialGroupObj);
    const groupContextValue = useMemo(() => ({group, setGroup}), [group]);

    useEffect(() => {
        store = new CreateGroupStore({
            axiosClient: ApiClient,
            alertFunc: props.setGroup,
            baseUrl: `${GroupsBaseUrl}`
        })
    }, [])

    const onSubmit = async () => {
        await store.create(group)
        history.push(urlService.groups())
    };

    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Leap4Breadcrumbs breadcrumbs={[{
                        text: "Alerts Dashboard",
                        link: urlService.groups(),
                        icon: <TocIcon/>
                    },
                        {
                            text: group?.name ? group.name : "New Group",
                            icon: <GroupsIcon/>
                        }]}
                    />
                </Grid>
                <Grid item xs={12}>
                    <GenericFormContainer mode={Mode.Create} onCreateOrEditFunc={onSubmit}>
                        <GroupContext.Provider value={groupContextValue}>
                            <DetailsForm mode={Mode.Create}/>
                        </GroupContext.Provider>
                    </GenericFormContainer>
                </Grid>
            </Grid>
        </>
    )
}


const mapStateToProps = (state: RootState) => ({});

export const AddGroup = connect(mapStateToProps, {
    setGroup: setAlert
})(_addGroup);

